import * as React from 'react'
import styles from '../../data.grid.styl'
import cx from 'classnames'
import Tooltip from '@src/components/common/tooltip'
import { ExtCellInfo, ColumnProps, ActionOption } from '../../models/'
import { getHtmlSelectorValueBy } from '@src/utils/css.selector.helper'
import Icon from '@src/components/common/icon'

export interface DefaultCellActionTemplateProps<T> {
  row?: ExtCellInfo<T>
  column?: ColumnProps<T>
  index?: number
  action: ActionOption<T>
}

export function DefaultCellActionTemplate<T>({
  action
}: DefaultCellActionTemplateProps<T>): React.ReactElement<
  DefaultCellActionTemplateProps<T>
> {
  if (action?.icon) {
    return (
      <Icon
        className={cx(styles.actionIcon, styles.camIcon, action.iconClassName)}
        name={action?.icon}
      />
    )
  }
  return <span className={action.iconClassName} />
}

export interface CellActionsProps<T> {
  row: ExtCellInfo<T>
  column: ColumnProps<T>
  columns: ColumnProps<T>[]
  resolvedState: () => any
}

//add React.memo
function CellActions<T>(props: CellActionsProps<T>) {
  const { row, column, columns, resolvedState } = props

  return (
    <>
      {column.actionOptions.map((action, index) => {
        const isHide =
          typeof action.hide === 'function'
            ? action.hide(row.original, row, column)
            : action.hide
        const defaultTemplate = (
          <DefaultCellActionTemplate
            row={row}
            column={column}
            index={index}
            action={action}
          />
        )

        const title = action.description || action.title
        const titleText =
          typeof title === 'function' ? title(row.original) : title
        const disabled =
          action.disabled && typeof action.disabled === 'function'
            ? action.disabled(row.original)
            : action.disabled

        return isHide ? null : (
          <Tooltip description={titleText} key={index}>
            <span
              data-description={titleText}
              data-action={getHtmlSelectorValueBy(
                titleText,
                'action_',
                '_',
                'lower'
              )}
              key={index}
              className={cx(styles.actionItem, action.className, {
                disabled
              })}
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                if (action.handler)
                  action.handler(row.original, columns, resolvedState)
              }}
            >
              {action.template
                ? action.template(row, column, action, defaultTemplate)
                : defaultTemplate}
            </span>
          </Tooltip>
        )
      })}
    </>
  )
}

export default React.memo(CellActions)
